import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../Common/SharedComponents";

interface IDeclarationProps extends IProcessComponentProps {
    data: any;
}

interface IDeclarationState {}

export class Declaration extends ProcessComponent<IDeclarationProps, IDeclarationState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                {SectionHeader("Declarations")}
                <CheckboxGroup
                    key={1}
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "I confirm that I wish to proceed with the review for the arrangement selected.",
                            value: data.includes(1),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                onChange([1], v);
                            },
                        },
                    ]}
                />
                <CheckboxGroup
                    key={2}
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label:
                                "I confirm that the customer has consented to a review of this arrangementat this time.",
                            value: data.includes(2),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                onChange([2], v);
                            },
                        },
                    ]}
                />
                <CheckboxGroup
                    key={3}
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm all",
                            disabled: this.props.isReview,
                            value: data.length == 2,
                            onChange: (v) => {
                                onChange([1, 2], v);
                            },
                        },
                    ]}
                />
                <hr />
            </>
        );
    }
}
